import { HttpClient } from '@angular/common/http';
import { Component, OnInit, OnChanges, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { TransferCaseCommonFunction } from 'app/outbox/transfer-functions';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { SendCaseSettings } from '../inbox-data';

@Component({
  selector: 'app-os-settings',
  templateUrl: './os-settings.component.html'
})
export class OSSettingsComponent implements OnInit, OnChanges {

  @Input() data: SendCaseSettings;
  @Input() existingCustomer: string;
  @Output() update = new EventEmitter();
  f = new TransferCaseCommonFunction(this.http);

  loadingNumber = 0;
  loadingState = 'loading';

  companyUsers;
  osTypes;
  osStatuses;
  osEconomyGroups;
  osDepartments;
  osCustomerGroups;

  constructor(private sharedData: SharedDataService, private http: HttpClient) { }

  ngOnInit() {
    //this.getTypes();
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log(changes);
    this.getTypes();
  }

  getTypes() {
    this.loadingNumber = 0;
    if (!this.companyUsers) {
      this.sharedData.companyUsers().subscribe({
        next: (data: any) => {
          //console.log(data);
          if (!!data && data.length > 0) {
            this.companyUsers = data.filter(x => !!x.externalId);
            this.data.responsibleId = localStorage.getItem('bearer');
          }
          this.checkLoading();
        }, 
        error: (err) => { console.error(err); this.loadingState = 'error'; }
      });
    } else {
      this.checkLoading();
    }
    if (!this.osTypes) {
      this.f.getOSTypes().subscribe({
        next: (data: any) => {
          //console.log(data);
          if (!!data && data.length > 0) {
            this.osTypes = data.sort((a, b) => a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1);
            //this.data.caseTypeId = data.sort((a, b) => a.id < b.id ? -1 : 1)[0].id;
          }
          this.checkLoading();
        }, 
        error: (err) => { console.error(err); this.loadingState = 'error'; }
      });
    } else {
      this.checkLoading();
    }
    if (!this.osStatuses) {
      this.f.getOSStatus().subscribe({
        next: (data: any) => {
          //console.log(data);
          if (!!data && data.length > 0) {
            this.osStatuses = data;
            this.data.osStatus = 99991;
          }
          this.checkLoading();
        }, 
        error: (err) => { console.error(err); this.loadingState = 'error'; }
      });
    } else {
      this.checkLoading();
    }
    if (!this.osEconomyGroups && !this.existingCustomer) {
      this.f.getOSEconomyGroups().subscribe({
        next: (data: any) => {
          //console.log(data);
          if (!!data && data.length > 0) {
            this.osEconomyGroups = data;
            this.data.economySystemGroupId = data.sort((a, b) => a.number < b.number ? -1 : 1)[0].number;
          }
          this.checkLoading();
        }, 
        error: (err) => { console.error(err); this.loadingState = 'error'; }
      });
    } else {
      this.checkLoading();
    }
    if (!this.osDepartments) {
      this.f.getOSDepartments().subscribe({
        next: (data: any) => {
          //console.log(data);
          if (!!data && data.length > 0) {
            this.osDepartments = data;
            //this.data.osDepartmentId = data.sort((a, b) => a.id < b.id ? -1 : 1)[0].id;
          }
          this.checkLoading();
        }, 
        error: (err) => { console.error(err); this.loadingState = 'error'; }
      });
    } else {
      this.checkLoading();
    }
    if (!this.osCustomerGroups && !this.existingCustomer) {
      this.f.getOSCustomerGroups().subscribe({
        next: (data: any) => {
          //console.log(data);
          if (!!data && data.length > 0) {
            this.osCustomerGroups = data.sort((a, b) => a.id < b.id ? -1 : 1);
            this.data.customerGroupId = data.sort((a, b) => a.id < b.id ? -1 : 1)[0].id;
          }
          this.checkLoading();
        }, 
        error: (err) => { console.error(err); this.loadingState = 'error'; }
      });
    } else {
      this.checkLoading();
    }
  }

  checkLoading() {
    this.loadingNumber = this.loadingNumber + 1;
    //console.log(this.loadingNumber)
    if (this.loadingNumber == 6) {
      this.loadingState = 'done';
      this.updateParent();
    }
  }

  updateParent() {
    //console.log(this.data);
    this.update.emit(this.data);
  }

}